// 做一层拦截
import sfax from 'sfax';

sfax.baseUrl = '';

export default config => sfax(config).then(res => res, res => {
    if (res && res.xhr && res.xhr.getResponseHeader('waf-valid')) {
        location.href = 'https://safe.focus.cn/?continue=' + window.btoa ? window.btoa(location.href) : location.href;
    } else {
        return Promise.reject(res)
    }
})


// WEBPACK FOOTER //
// ./src/model/api/sfax.js